import { Badge, Box, Grid, IconButton, Stack, Typography, useMediaQuery } from '@mui/material';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';
import { useCallback, useMemo, useState } from 'react';
import { GridView, Task, ViewList, HomeRepairServiceOutlined, AccessTime, Construction, CropOriginal, PrecisionManufacturing, BookOnline, FolderOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';
import { EmployeeMobileVovClient } from '../../../ApiOld/Api/ApiServerVov';

export interface IMobileMenuProps {
}


export default function MobileMenu(props: IMobileMenuProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { getFirstPartPath, disabledModules, setModuleButton, setModuleSecondButton, unreadMessages, diagnosticAlerts } = useEmployeeContext();
    const params = useParams();
    const [diaryDisabled, setDiaryDisabled] = useState(false);
    const [projectsDisabled, setProjectsDisabled] = useState(false);

    const { authorizedMobileEmployeeApi } = useMobileApi(EmployeeMobileVovClient);

    React.useEffect(() => {
    }, []);

    React.useEffect(() => {
        const bearer = localStorage.getItem('old_bearer');
        if (diagnosticAlerts)
            enqueueSnackbar('bearer: ' + bearer, { variant: 'info' });
        if (bearer === null) {
            setDiaryDisabled(true);
            setProjectsDisabled(true);
        }
    }, [diagnosticAlerts]);
    const [gridOpened, setGridOpened] = useState(JSON.parse(localStorage.getItem("mobile_menu_view") ?? 'true'));
    const biggerThan350 = useMediaQuery('(min-width:350px)');
    const iconSize = gridOpened ? (biggerThan350 ? 60 : 40) : 50;
    const Routes = useMemo(
        () => [
            {
                title: 'Attendance',
                children: [
                    { path: 'employee/activities', title: 'Activities', icon: <HomeRepairServiceOutlined /> },
                    {
                        path: 'employee/attendance',
                        title: 'Attendance',
                        icon: <AccessTime />,
                        disabled: disabledModules?.includes('Docházka'),
                    },
                ],
            },
            {
                title: 'Modules',
                children: [
                    {
                        path: 'userlayout/diary/diarymobilenoupper/',
                        title: 'Construction Diary',
                        icon: <BookOnline />,
                        disabled: disabledModules?.includes('Deník') || diaryDisabled,
                    },
                    {
                        path: 'employee/wealth',
                        title: 'Property',
                        icon: <PrecisionManufacturing />,
                        disabled: disabledModules?.includes('Majetek'),
                    },
                    {
                        path: 'employee/requests',
                        title: 'Tasks',
                        icon: <Task />,
                        notifications: unreadMessages,
                        disabled: disabledModules?.includes('Úkoly'),
                    },
                ],
            },
            {
                title: 'Other',
                children: [
                    { path: 'employee/photos', title: 'Photos', icon: <CropOriginal /> },
                    { path: 'employee/documents', title: 'Documents', icon: <FolderOutlined /> },
                    { path: 'userlayout/projectsnoupper/', title: 'Projects', icon: <Construction />, disabled: disabledModules?.includes('Projekty') || projectsDisabled },
                ],
            },
        ],
        [disabledModules, diaryDisabled, projectsDisabled, unreadMessages]
    );

    const handleGridChange = useCallback(() => {
        setGridOpened(!gridOpened);
        localStorage.setItem("mobile_menu_view", JSON.stringify(!gridOpened));
    }, [gridOpened]);

    React.useEffect(() => {
        setModuleButton(
            <Stack direction={'row'} alignItems={'center'}
                sx={{ background: '#404040', borderRadius: 4, pl: 1, pr: 2, maxHeight: 32, ml: 1 }}
                onClick={() => setGridOpened(!gridOpened)}
            >
                <IconButton onClick={handleGridChange}>
                    {gridOpened ? (
                        <ViewList sx={{ color: 'white' }} />
                    ) : (
                        <GridView sx={{ color: 'white' }} />
                    )}
                </IconButton>
                <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}>{t('SwitchView')}</Typography>
            </Stack>);
        setModuleSecondButton && setModuleSecondButton(null);
    }, [gridOpened, handleGridChange, setModuleButton, setModuleSecondButton, t]);
    return (
        <Box>
            <Box sx={{ height: '100%', width: '100%', overflow: 'auto', position: 'fixed' }}>
                {Routes.map((section) => (
                    <Box key={section.title} sx={{ px: 2, py: 1 }}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: 14, mb: 1 }}>{t(section.title)}</Typography>
                        <Grid container spacing={2}>
                            {section.children.map((route) => (
                                <Grid
                                    item
                                    xs={gridOpened ? 4 : 12}
                                    sm={gridOpened ? 2 : 12}
                                    key={route.path}
                                    sx={{ cursor: route.disabled ? 'not-allowed' : 'pointer' }}
                                >
                                    {gridOpened ?
                                        <Box
                                            onClick={() => {
                                                if (route.disabled) return;

                                                if (route.path === 'userlayout/diary/diarymobilenoupper/' || route.path === 'userlayout/projectsnoupper/') {
                                                    authorizedMobileEmployeeApi.employeeMe().then((res) => {
                                                        if (res) {
                                                            if (res.adminAccessToken)
                                                                localStorage.setItem('old_bearer', res.adminAccessToken);
                                                            if (res.adminRefreshToken)
                                                                localStorage.setItem('old_refresh_token', res.adminRefreshToken);
                                                            setModuleButton?.(null);
                                                            navigate(getFirstPartPath(params.lang ?? '') + route.path);
                                                        }
                                                    }).catch(() => {
                                                        // setLoggedIn(false);
                                                    });
                                                }
                                                else {
                                                    setModuleButton?.(null);
                                                    navigate(getFirstPartPath(params.lang ?? '') + route.path);
                                                }
                                            }
                                            }
                                            sx={{
                                                boxShadow: 2,
                                                borderRadius: 1,
                                                p: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%',
                                                aspectRatio: 1,
                                            }}
                                        >
                                            <Box

                                                display='flex'
                                                flexDirection={'column'}
                                                justifyContent={'center'}
                                                alignItems={'center'}
                                                height={'100%'}
                                                gap={0.5}>
                                                <Badge
                                                    badgeContent={route.notifications || null}
                                                    sx={{
                                                        '& .MuiBadge-badge': {
                                                            background: route.notifications && '#404040',
                                                            color: 'white',
                                                            fontSize: 10,
                                                            fontWeight: 'bold',
                                                            height: 16,
                                                            width: 16,
                                                            borderRadius: '50%',
                                                            transform: 'scale(1) translate(50%, -50%)',
                                                        },
                                                    }}
                                                    overlap="circular"
                                                >
                                                    <Box width='100%' sx={{ color: route.disabled ? '#DCDCDC' : '#FFC600' }}>
                                                        {React.cloneElement(route.icon, { sx: { width: iconSize, height: iconSize } })}
                                                    </Box>
                                                </Badge>
                                                <Typography
                                                    sx={{
                                                        color: route.disabled ? '#DCDCDC' : '#101920',
                                                        textAlign: 'center',
                                                        fontSize: 12,
                                                        lineHeight: 1
                                                    }}>
                                                    {t(route.title)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        : (<Box
                                            onClick={() => {
                                                if (route.disabled) return;

                                                if (route.path === 'userlayout/diary/diarymobilenoupper/' || route.path === 'userlayout/projectsnoupper/') {
                                                    authorizedMobileEmployeeApi.employeeMe().then((res) => {
                                                        if (res) {
                                                            if (res.adminAccessToken)
                                                                localStorage.setItem('old_bearer', res.adminAccessToken);
                                                            if (res.adminRefreshToken)
                                                                localStorage.setItem('old_refresh_token', res.adminRefreshToken);
                                                            setModuleButton?.(null);
                                                            navigate(getFirstPartPath(params.lang ?? '') + route.path);
                                                        }
                                                    }).catch(() => {
                                                        // setLoggedIn(false);
                                                    });
                                                }
                                                else {
                                                    setModuleButton?.(null);
                                                    navigate(getFirstPartPath(params.lang ?? '') + route.path);
                                                }
                                            }
                                            }
                                            sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {React.cloneElement(route.icon, { sx: { width: iconSize, height: iconSize, color: route.disabled ? '#DCDCDC' : '#FFC600', pr: 2 } })}
                                                <Box sx={{ color: route.disabled ? '#DCDCDC' : '#101920' }}>
                                                    {t(route.title)}
                                                </Box>
                                            </Box>
                                            {route.notifications > 0 && (
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Badge
                                                        badgeContent={route.notifications}
                                                        sx={{
                                                            '& .MuiBadge-badge': {
                                                                background: '#404040',
                                                                color: 'white',
                                                                fontSize: 10,
                                                                fontWeight: 'bold',
                                                                height: 16,
                                                                width: 16,
                                                                borderRadius: '50%',
                                                                transform: 'scale(1) translate(50%, -50%)',
                                                            },
                                                        }}
                                                        overlap="circular"
                                                    />
                                                    <Typography sx={{ pl: 2, fontSize: 12, fontWeight: 'bold' }}>
                                                        {t('New')}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>)}
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                ))}
            </Box>
        </Box>


    );
}
